import { Link } from "react-router-dom";

const PackNGO = () => {
  return (
    <div>

      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
             PackNGo
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS offers a hassle-free and relaxed experience of moving from one premises to another. 
              We take care of the smallest details of the move. Professional TCS teams with extensive experience in packing, 
              shifting and transportation provide guidance to every customer throughout the process. Single point-of-contact, 
              flexible and transparent quotations and proposals, customised documentation, organised and planned packing 
              and movement, and temporary storage facilities available at Karachi, Lahore and Islamabad at TCS warehouses 
              leave nothing for a chance.</p> 

            {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
            Single point-of-contact, flexible and transparent quotations and proposals, customised documentation, 
            organised and planned packing and movement, trained and professional teams and temporary storage 
            facilities available at Karachi, Lahore & Islamabad at TCS warehouses leave nothing for a chance
            </p> */}

                <div className="mt-[1rem]  w-[100%]">
                        
                  <div className="flex justify-left">
                      <Link to="/pack-n-go" className="flex justify-center text-center items-center rounded-sm h-9 mt-[2px] text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Find Out More</Link>
                      
                  </div>
                </div>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/image22.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
    
      </div>
      
    </div>
  );
};

export default PackNGO;
